import { StateCreator } from 'zustand';
import { MessagesSlice } from './types';

export const createMessagesSlice: StateCreator<MessagesSlice> = (set) => ({
  messages: [],
  setMessages: (messages) => set({ messages }),
  addMessage: (message) =>
    set((state) => ({
      messages: [...state.messages, message],
    })),
});
